export default __webpack_public_path__ + "static/media/0004.dd26f301.jpg";